import type { BodyProps } from "./body.types";
import { bodyStyles } from "./body.styles";

export const Body = (props: BodyProps) => {
  const { children, as = "p", size = "1", weight = "normal", className, ...rest } = props;

  const BodyTag = as;

  const classes = bodyStyles({ size, weight, className });

  return (
    <BodyTag className={classes} {...rest}>
      {children}
    </BodyTag>
  );
};
